import { getUserInfoQuery } from '~/apis/auth';
import { MarqCommonEnumsClientClientRoleEnum } from '~/swagger/data-contracts';

const hasHomePageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.role !== MarqCommonEnumsClientClientRoleEnum.LimitedAccess;
  return isAllowed;
};
const hasPerformancePageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.role !== MarqCommonEnumsClientClientRoleEnum.LimitedAccess;
  return isAllowed;
};
const hasPerformanceReportPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.role !== MarqCommonEnumsClientClientRoleEnum.LimitedAccess;
  return isAllowed;
};
const hasPortfolioAssetsPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed =
    !authData?.use_piracy && (authData?.use_ecommerce || authData?.use_social_media || !authData?.use_stand_alone);
  return isAllowed;
};
// todo-@elie: 11997 - Counterfeit vs Marketplace 네이밍 고민중
const hasPortfolioCounterfeitAssetsPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed =
    authData?.use_piracy && (authData?.use_ecommerce || authData?.use_social_media || !authData?.use_stand_alone);
  return isAllowed;
};
// todo-@elie: 11997 - Piracy vs WebsiteContent 네이밍 고민중
const hasPortfolioPiracyAssetsPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_piracy;
  return isAllowed;
};
const hasPortfolioInfringingImagesPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_ecommerce || authData?.use_social_media || !authData?.use_stand_alone;
  return isAllowed;
};
const hasPortfolioAuthorizedSellersPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed =
    authData?.use_ecommerce || authData?.use_social_media || authData?.use_stand_alone || authData?.use_domain_name;
  return isAllowed;
};
const hasMarketplacePageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_ecommerce;
  return isAllowed;
};
const hasSocialMediaPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_social_media || authData?.use_piracy;
  return isAllowed;
};
const hasWebsiteContentPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_stand_alone || authData?.use_piracy;
  return isAllowed;
};
const hasDomainNamesPageAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowed = authData?.use_domain_name;
  return isAllowed;
};
const hasSellerPagesAccess = async () => {
  const authData = await getUserInfoQuery();

  // role == limited access 인 경우에는 모든 브랜드+모든 국가에 권한이 있을 때에만 이 화면에 접근 가능.
  const isAllowedRole = !(
    authData?.role === MarqCommonEnumsClientClientRoleEnum.LimitedAccess &&
    (!authData?.limited_access_policy?.has_all_brand_access || !authData?.limited_access_policy?.has_all_country_access)
  );

  const isAllowedActiveDomainType = authData?.use_ecommerce || authData?.use_social_media;

  return isAllowedRole && isAllowedActiveDomainType;
};

const hasSettingTabAccess = async () => {
  const authData = await getUserInfoQuery();
  const isAllowedBillingTabRole = authData?.role !== MarqCommonEnumsClientClientRoleEnum.LimitedAccess;
  const isAllowedPeopleTabRole = authData?.role
    ? [MarqCommonEnumsClientClientRoleEnum.Admin, MarqCommonEnumsClientClientRoleEnum.Owner].includes(authData.role)
    : false;
  const isAllowedCreditsTabRole = !!authData?.reporting_cap_client;

  return {
    billing: isAllowedBillingTabRole,
    people: isAllowedPeopleTabRole,
    credits: isAllowedCreditsTabRole,
  };
};

const hasPriceMonitoringPageAccess = async () => {
  const authData = await getUserInfoQuery();
  return authData?.use_map_monitoring;
};

const hasConversationalAssistantPageAccess = async () => {
  const authData = await getUserInfoQuery();
  return authData?.use_cv_assistant;
};

export const PermissionMap = {
  Home: hasHomePageAccess,
  Performance: hasPerformancePageAccess,
  PerformanceReport: hasPerformanceReportPageAccess,
  PortfolioAssets: hasPortfolioAssetsPageAccess,
  PortfolioCounterfeitAssets: hasPortfolioCounterfeitAssetsPageAccess,
  PortfolioPiracyAssets: hasPortfolioPiracyAssetsPageAccess,
  PortfolioInfringingImages: hasPortfolioInfringingImagesPageAccess,
  PortfolioAuthorizedSellers: hasPortfolioAuthorizedSellersPageAccess,
  Marketplace: hasMarketplacePageAccess,
  SocialMedia: hasSocialMediaPageAccess,
  WebsiteContent: hasWebsiteContentPageAccess,
  DomainNames: hasDomainNamesPageAccess,
  Seller: hasSellerPagesAccess,
  PriceMonitoring: hasPriceMonitoringPageAccess,
  SettingTab: hasSettingTabAccess,
  ConversationalAssistant: hasConversationalAssistantPageAccess,
};
